import { getHeaderTitle } from '@react-navigation/elements'
import { RouteProp } from '@react-navigation/native'
import { NativeStackNavigationOptions } from '@react-navigation/native-stack'
import { router, useNavigation } from 'expo-router'
import { useEffect, useState } from 'react'
import { Platform, View } from 'react-native'
import { Appbar } from 'react-native-paper'
import { useUnistyles } from 'react-native-unistyles'

import UniIconButton from '@/components/unistyles/UniIconButton'

const Header = ({
  children,
  replaceContentWithChildren,
  route,
  title,
  transparent,
  options,
}: {
  children?: React.ReactNode
  replaceContentWithChildren?: boolean
  route: RouteProp<Record<string, object | undefined>, string>
  title?: string
  transparent?: boolean
  options: NativeStackNavigationOptions
}) => {
  const { theme } = useUnistyles()
  const navigation = useNavigation()
  const [showBackButton, setShowBackButton] = useState(false)

  useEffect(() => {
    const historySize = navigation.getState()?.history?.length || 0
    setShowBackButton(historySize > 2)

    navigation.addListener('state', () => {
      setShowBackButton(navigation.canGoBack())
    })

    return () => {
      navigation.removeListener('focus', () => {})
    }
  }, [navigation])

  return (
    <Appbar.Header
      elevated={false}
      style={{
        paddingLeft: showBackButton ? 0 : theme.tokens.spacing[4],
        paddingRight: headerXPadding,
        backgroundColor: transparent ? 'transparent' : theme.colors.surface,
        borderBottomColor: theme.colors.cardBorder,
        borderBottomWidth: 1,
      }}
    >
      <>
        {showBackButton && (
          <UniIconButton
            icon="arrow-left"
            iconColor={theme.colors.primary}
            onPress={() => {
              router.back()
              // setShowBackButton(navigation.canGoBack())
            }}
            testID="back-icon-button"
          />
        )}

        {replaceContentWithChildren ? (
          children
        ) : (
          <>
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Appbar.Content
                style={{ flex: Platform.OS === 'web' ? 0.4 : 1 }}
                title={title || getHeaderTitle(options, route.name)}
                titleMaxFontSizeMultiplier={1.5}
              />
              {children}
            </View>
            {options.headerRight && (
              <>{options.headerRight({ canGoBack: showBackButton })}</>
            )}
          </>
        )}
      </>
    </Appbar.Header>
  )
}

const headerXPadding = 16

export default Header
